import React from 'react'
import styled from '@emotion/styled'
import PendingInvitationCard from './PendingInvitationCard'

type PendingInvitation = {
  id: string
  invitedEmail: string
  invitedName: string | null
  invitedAt: string
  expiresAt: string
  organization: {
    id: string
    name: string
    slug: string
    organizationType: string | null
    logoPublicId: string | null
    memberCount: number
  }
}

type Props = {
  invitations: PendingInvitation[]
  onAccept: (org: { id: string; name: string }) => void
  onDecline: () => void
}

const PendingInvitationsSection: React.FC<Props> = ({ invitations, onAccept, onDecline }) => {
  return (
    <Container>
      <Header>
        <Title>Pending Invitations</Title>
        <Badge>{invitations.length}</Badge>
      </Header>
      <InvitationsList>
        {invitations.map((invitation) => (
          <PendingInvitationCard
            key={invitation.id}
            invitation={invitation}
            onAccept={onAccept}
            onDecline={onDecline}
          />
        ))}
      </InvitationsList>
    </Container>
  )
}

const Container = styled.div`
  margin-bottom: 24px;
  padding: 16px;
  background: #fdf2f8;
  border: 1px solid #fce7f3;
  border-radius: 8px;
`

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
`

const Title = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #831843;
`

const Badge = styled.span`
  background: #db2777;
  color: white;
  border-radius: 12px;
  padding: 2px 8px;
  font-size: 12px;
  font-weight: 600;
`

const InvitationsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export default PendingInvitationsSection
